skrilla.controller('dota2ContestsCtrl', function ($scope, cacheService, dota2ContestService, adminService) {
    $scope.hasRole = adminService.hasRole;
    $scope.pageKey = "contests";
    $scope.contests = cacheService.getObjectOrElse("dota2-dailyContests", []);
    $scope.selectedContests = [];
    var callback = function(){
        $scope.selectedContests.forEach(function(contest){contest.selected = false;});
        $scope.selectedContests = [];
        cacheService.registerObject("selectedDota2Contests", $scope.selectedContests);
    }


    $scope.clicked = function(contest){
        if(contest.selected === false || contest.selected === undefined) {
            $scope.selectedContests.push(contest);
        }
        else{
            $scope.selectedContests = $scope.selectedContests.filter(function(_contest){return _contest.id !== contest.id});
        }
        cacheService.registerObject("selectedDota2Contests", $scope.selectedContests);
    }

    $scope.action = function(){
        dota2ContestService.openActionModal(callback);
    }

});

